import React from 'react'
import './style.css'

export default class MagicAttribute extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            property: props.data
        };
    }

    renderValues() {
        return (
            <p className="magic-property">{this.state.property.name}</p>
        );
    }

    render() {
        return (
            <div>{this.renderValues()}</div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/item/magic-attribute/index.js